import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Support({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M18.5 10V9.5C18.5 5.91 15.59 3 12 3C8.41 3 5.5 5.91 5.5 9.5V10M13.875 20C13.875 19.31 13.315 18.75 12.625 18.75H11.375C10.685 18.75 10.125 19.31 10.125 20C10.125 20.69 10.685 21.25 11.375 21.25H12.625C13.315 21.25 13.875 20.69 13.875 20ZM13.875 20H15.995C17.095 20 17.995 19.1 17.995 18V17M19 17H18C17.44 17 17 16.55 17 16V11C17 10.44 17.44 10 18 10H19C20.1 10 21 10.89 21 12V15C21 16.1 20.1 17 19 17ZM6 17H5C3.895 17 3 16.1 3 15V12C3 10.89 3.895 10 5 10H6C6.55 10 7 10.44 7 11V16C7 16.55 6.55 17 6 17Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Support;